


export type BillDocumentSource = 'Receipt' | 'Upload' | 'Chat';

export const BillDocumentSource = {
    Receipt: 'Receipt' as BillDocumentSource,
    Upload: 'Upload' as BillDocumentSource,
    Chat: 'Chat' as BillDocumentSource
};

